import React from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import "../../styles/scss/bootstrap.scss";
import "../../styles/scss/daterangepicker.scss";

const DateRangePickers = props => {
  const onShowCalender = () => {
    // console.log("From date picker", document.querySelector(".drp-selected").innerHTML)
    // document.querySelector(".drp-selected").innerHTML = `${moment(props.startDate).format("ddd, DD MMM YYYY")} - ${moment(props.endDate).format("ddd, DD MMM YYYY")}`;
  };

  if(props.source === "ADD_ACTIVITY") {
    if(!props.isCompleted) {
      if (parseInt(props.startDate) && parseInt(props.endDate))
        return (
          <DateRangePicker
            opens="right"
            drops="auto"
            locale={{ format: "ddd, DD MMM YY" }}
            ranges={{
              "Today": [
                moment(),
                moment()
              ],
              "Today - Tomorrow": [
                moment(),
                moment().add(1, "day")
              ],
              "Next 7 days": [
                moment(),
                moment().add(6, "day")
              ],
              "Next 14 days": [
                moment(),
                moment().add(13, "day")
              ],
              "Next month": [
                moment(),
                moment().add(1, "month")
              ],
              "Next 3 months": [
                moment(),
                moment().add(3, "month")
              ],
              "Next year": [
                moment(),
                moment().add(1, "year")
              ],
              "Continuous": [
                moment(),
                moment().add(5, "year")
              ]
            }}
            //minDate={moment(props.startDate).format("M/DD/YYYY")}
            // maxDate={props.maxDate && moment(props.maxDate).format("DD MMM YYYY")}
            startDate={moment(props.startDate).format("ddd, DD MMM YY")}
            endDate={moment(props.endDate).format("ddd, DD MMM YY")}
            onApply={props.onChangeDate}
          >
            {props.children}
          </DateRangePicker>
        )
      else
        return (
          <DateRangePicker
            opens="right"
            drops="auto"
            locale={{ format: "ddd, DD MMM YY" }}
            ranges={{
              "Today": [
                moment(),
                moment()
              ],
              "Today - Tomorrow": [
                moment(),
                moment().add(1, "day")
              ],
              "Next 7 days": [
                moment(),
                moment().add(6, "day")
              ],
              "Next 14 days": [
                moment(),
                moment().add(13, "day")
              ],
              "Next month": [
                moment(),
                moment().add(1, "month")
              ],
              "Next 3 months": [
                moment(),
                moment().add(3, "month")
              ],
              "Next year": [
                moment(),
                moment().add(1, "year")
              ],
              "Continuous": [
                moment(),
                moment().add(5, "year")
              ]
            }}
            //minDate={moment(props.startDate).format("M/DD/YYYY")}
            // maxDate={props.maxDate && moment(props.maxDate).format("DD MMM YYYY")}
            onApply={props.onChangeDate}
          >
            {props.children}
          </DateRangePicker>
        )
    } else {
      const completedRanges = {
        "Today": [moment(), moment()],
        "Yesterday - Today": [moment().subtract(1, "day"), moment()],
        "Last 7 days": [moment().subtract(6, "day"), moment()],
        "Last 14 days": [moment().subtract(13, "day"), moment()],
        "Last month": [moment().subtract(1, "month"), moment()],
        "Last 3 months": [moment().subtract(3, "month"), moment()],
        "Last year": [moment().subtract(1, "year"), moment()]
      };
      const restrictedDays = props.allowedDays && parseInt(props.allowedDays) > 0
        ? parseInt(props.allowedDays)
        : null;
      const completedMinDate = restrictedDays
        ? moment().subtract(restrictedDays, "day").startOf("day")
        : null;
      const shownRanges = restrictedDays
        ? {
            "Today": [moment(), moment()],
            "Yesterday": [moment().subtract(1, "day"), moment().subtract(1, "day")],
          }
        : completedRanges;

      if (parseInt(props.startDate) && parseInt(props.endDate))
        return (
          <DateRangePicker
            opens="right"
            drops="auto"
            locale={{ format: "ddd, DD MMM YY" }}
            ranges={shownRanges}
            minDate={completedMinDate || undefined}
            maxDate={props.maxDate && moment(props.maxDate).format("ddd, DD MMM YY")}
            startDate={moment(props.startDate).format("ddd, DD MMM YY")}
            endDate={moment(props.endDate).format("ddd, DD MMM YY")}
            onApply={props.onChangeDate}
          >
            {props.children}
          </DateRangePicker>
        )
      else
        return (
          <DateRangePicker
            opens="right"
            drops="auto"
            locale={{ format: "ddd, DD MMM YY" }}
            ranges={shownRanges}
            minDate={completedMinDate || undefined}
            maxDate={props.maxDate && moment(props.maxDate).format("ddd, DD MMM YY")}
            onApply={props.onChangeDate}
          >
            {props.children}
          </DateRangePicker>
        )
    }
  }
  else if(props.source === "EDIT_ACTIVITY") {
    const editRestrictedDays = props.allowedDays && parseInt(props.allowedDays) > 0
      ? parseInt(props.allowedDays)
      : null;
    const editMinDate = editRestrictedDays
      ? moment().subtract(editRestrictedDays, "day").startOf("day")
      : undefined;
    return (
      <DateRangePicker
      singleDatePicker={true}
      autoApply={true}
      locale={{ format: "ddd, DD MMM YY", customRangeLabel: "Custom date" }}
      minDate={editMinDate}
      maxDate={props.maxDate && moment(props.maxDate).format("ddd, DD MMM YY")}
      startDate={moment(props.startDate).format("ddd, DD MMM YY")}
      endDate={moment(props.endDate).format("ddd, DD MMM YY")}
      onApply={props.onChangeDate}
      opens="right"
      drops="auto"
    >
      {props.children}
    </DateRangePicker>
    )
  }

  else if (props.source === "DASHBOARD")
    return (
      <DateRangePicker
        onShow={onShowCalender}
        opens="right"
        locale={{ format: "ddd, DD MMM YY", customRangeLabel: "Custom range" }}
        ranges={{
          "Today": [
            moment(),
            moment()
          ],
          "Yesterday": [
            moment().subtract(1, "day"),
            moment().subtract(1, "day")
          ],
          "Last 7 days": [
            moment().subtract(6, "days"),
            moment()
          ],
          "Last 30 days": [
            moment().subtract(29, "days"),
            moment()
          ],
          "This month": [
            moment().startOf("month"),
            moment().endOf("month")
          ],
          "Last month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month")
          ],
        }}
        //minDate={moment(props.startDate).format("M/DD/YYYY")}
        maxDate={props.maxDate && moment(props.maxDate).format("ddd, DD MMM YY")}
        startDate={moment(props.startDate).format("ddd, DD MMM YY")}
        endDate={moment(props.endDate).format("ddd, DD MMM YY")}
        onApply={props.onChangeDate}
      >
        {props.children}
      </DateRangePicker>
    );
  else if (props.source === "MISSED_TIME_SHEET") {
    return (
    <DateRangePicker
      singleDatePicker={true}
      autoApply={true}
      locale={{ format: "ddd, DD MMM YY", customRangeLabel: "Custom date" }}
      maxDate={props.maxDate && moment(props.maxDate).format("ddd, DD MMM YY")}
      startDate={moment(props.startDate).format("ddd, DD MMM YY")}
      endDate={moment(props.endDate).format("ddd, DD MMM YY")}
      onApply={props.onChangeDate}
      opens="left"
      ranges={{
        "Today": [
          moment(),
          moment()
        ],
        "Yesterday": [
          moment().subtract(1, "day"),
          moment().subtract(1, "day")
        ]
      }}
    >
      {props.children}
    </DateRangePicker>
    )
  } else if (props.source === "CHECKLIST_ITEM") {
    if (props.startDate && props.endDate) 
    return (
      <DateRangePicker
        singleDatePicker={true}
        autoApply={true}
        locale={{ format: "ddd, DD MMM YY" }}
        startDate={props.startDate ? moment(props.startDate).format("ddd, DD MMM YY") : null}
        endDate={props.endDate ? moment(props.endDate).format("ddd, DD MMM YY") : null}
        onApply={props.onChangeDate}
        opens="right"
        drops="auto"
      >
        {props.children}
      </DateRangePicker>
      )
    else return (
      <DateRangePicker
        singleDatePicker={true}
        autoApply={true}
        locale={{ format: "ddd, DD MMM YY" }}
        onApply={props.onChangeDate}
        opens="right"
        drops="auto"
      >
        {props.children}
      </DateRangePicker>
      )
  }
  else if (parseInt(props.startDate) && parseInt(props.endDate))
    return (
      <DateRangePicker
        onShow={onShowCalender}
        opens="right"
        locale={{ format: "DD MMM YYYY" }}
        //minDate={moment(props.startDate).format("M/DD/YYYY")}
        maxDate={props.maxDate && moment(props.maxDate).format("DD MMM YYYY")}
        startDate={moment(props.startDate).format("DD MMM YYYY")}
        endDate={moment(props.endDate).format("DD MMM YYYY")}
        onApply={props.onChangeDate}
      >
        {props.children}
      </DateRangePicker>
    );
  else
    return (
      <DateRangePicker
        onShow={onShowCalender}
        opens="right"
        locale={{ format: "DD MMM YYYY" }}
        //minDate={moment(props.startDate).format("M/DD/YYYY")}
        maxDate={props.maxDate && moment(props.maxDate).format("DD MMM YYYY")}
        // startDate={moment(props.startDate).format("M/DD/YYYY")}
        // endDate={moment(props.endDate).format("M/DD/YYYY")}
        onApply={props.onChangeDate}
      >
        {props.children}
      </DateRangePicker>
    );
};

export default DateRangePickers;
